import { render, staticRenderFns } from "./BigHeader.vue?vue&type=template&id=284e6144&scoped=true&"
import script from "./BigHeader.vue?vue&type=script&lang=js&"
export * from "./BigHeader.vue?vue&type=script&lang=js&"
import style0 from "./BigHeader.vue?vue&type=style&index=0&id=284e6144&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284e6144",
  null
  
)

export default component.exports